import { Card, Col, Row } from "antd";
import { type PropsWithChildren } from "react";
import styled from "styled-components";

import { OutageBanner } from "../../../appV2/OutageBanner/OutageBanner";
import { BunnyLogo } from "../../../appV2/redesign/components/Logos";

const LoginContainer = styled(Row)`
  height: 100% !important;
  background-image: url(${process.env.REACT_APP_BASE_PATH || "/"}facilityImage.jpg);
  background-size: cover;

  .ant-card {
    width: 80%;
    border-radius: 5px;
    form {
      text-align: center;
    }
  }
`;

function LoginLayout({ children }: PropsWithChildren) {
  return (
    <LoginContainer justify="center" align="middle">
      <OutageBanner />
      {/* @ts-expect-error FIXME this wrong type */}
      <Col xs={{ span: 24 }} md={{ span: 16 }} lg={{ span: 12 }} align="center">
        <Card>
          <BunnyLogo height={100} width={300} margin={"0px 0px 24px 0px"} />
          <Row justify="center">
            {/* @ts-expect-error FIXME this wrong type */}
            <Col xs={{ span: 24 }} sm={{ span: 22 }} lg={{ span: 20 }} align="center">
              {children}
            </Col>
          </Row>
        </Card>
      </Col>
    </LoginContainer>
  );
}

export { LoginLayout };
